const development_tenant = {
    notification: 'Sei in modalità di sviluppo',
};
export default Object.freeze(development_tenant);
